"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onFinishDraggingInternal = void 0;
const onFinishDraggingInternal = (prevEvent, eventToUpdate, store, setContext, type, onEventDragFinish, resetPosition) => {
    const events = store.events;
    const result = events === null || events === void 0 ? void 0 : events.map((item) => {
        if (item.id === eventToUpdate.id) {
            return eventToUpdate;
        }
        else {
            return item;
        }
    });
    // return updated data with callback
    if (onEventDragFinish) {
        onEventDragFinish(prevEvent, eventToUpdate, result, resetPosition);
    }
};
exports.onFinishDraggingInternal = onFinishDraggingInternal;
